import React, { useEffect, useState } from "react";
import GlobalDialog from "../../mui/Dialogue/GlobalDialog";
import {
  AddButton,
  CancelButton,
  EditButton,
  SubmitButton,
  UpdateButton,
} from "../../mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import GlobalSelectField from "../../mui/GlobalSelectField";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import {
  getLeadsForDeo,
  postLeadForDeo,
  updateLeadForDeo,
} from "../../../redux/features/deoSlice";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
const preferredTypes = [
  { id: 1, name: "Course" },
  { id: 2, name: "Club" },
];

const genders = [
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
];

const AddOrEditLeadDeo = ({ row, dispatchParams }) => {
  const { loading, courses, syllabuses,classes } = useSelector((store) => store.deo);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const initialValues = {
    leadName: row ? row.lead_name : "",
    age: row ? row.age : "",
    gender: row ? (row.gender == "Male" ? 1 : 2) : "",
    class: row ? row.lead_class : "",
    syllabusId: row ? row.lead_syllabus_id : "",
    preferredType: row ? (row.type == "Course" ? 1 : 2) : "",
    courseId: row ? row.lead_preffered_course : "",
    clubName: row ? row.lead_preffered_club : "",
    parentName: row ? row.lead_father_name : "",
    countryCode: row ? row.lead_country_code : "",
    contactNumber: row ? row.lead_mob_no : "",
    whatsappNumber: row ? row.lead_whatsapp_no : "",
    remarks: row ? row.lead_remarks : "",
    place: row ? row.lead_place : "",
    email: row ? row.lead_email_id : "",
  };
  const schema = Yup.object({
    leadName: Yup.string().required("Lead Name is required"),
    age: Yup.number().required("Age is required"),
    gender: Yup.mixed().required("Gender is required"),
    class: Yup.number().required("Class is required"),
    syllabusId: Yup.number().required("Syllabus is required"),
    preferredType: Yup.number().required("Preferred Type is required"),
    courseId: Yup.number().when("preferredType", {
      is: 1,
      then: Yup.number().required("Course is required"),
      otherwise: Yup.number().nullable(),
    }),
    clubName: Yup.string().when("preferredType", {
      is: 2,
      then: Yup.string().required("Club is required"),
      otherwise: Yup.string().nullable(),
    }),
    parentName: Yup.string().required("Parent Name is required"),
    countryCode: Yup.string().required("Country Code is required"),
    contactNumber: Yup.number().required("Contact Number is required"),
    whatsappNumber: Yup.number().required("Whatsapp Number is required"),
    remarks: Yup.string().required("Remarks is required"),
    place: Yup.string().required("Place is required"),
    email: Yup.string().email().required("Email is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = [
        {
          lead_name: values.leadName,
          lead_country_code: values.countryCode,
          lead_mob_no: values.contactNumber,
          age: values.age,
          gender: values.gender == 1 ? "Male" : "Female",
          lead_class: values.class,
          lead_syllabus_id: values.syllabusId,
          lead_preffered_course:
            values.preferredType == 1 ? values.courseId : null, //if preferredType is 1(COURSE) then course id else null
          lead_whatsapp_no: values.whatsappNumber,
          lead_preffered_club:
            values.preferredType == 2 ? values.clubName : null, //if preferredType is 2(CLUB) then club name else null
          lead_remarks: values.remarks,
          lead_father_name: values.parentName,
          lead_place: values.place,
          lead_email_id: values.email,
        },
      ];
      if (row) {
        data[0] = { ...data[0], lead_id: row.lead_id };
        dispatch(updateLeadForDeo({ data })).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(getLeadsForDeo(dispatchParams));
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      } else {
        dispatch(postLeadForDeo({ data })).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            dispatch(getLeadsForDeo(dispatchParams));
            handleCancel();
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      }
    },
  });

  useEffect(() => {
    //WHILE SWITCHING IN BETWN COURSE AND CLUB SETTING THE FIELD VALUE TO NULL WITH RESPECT TO PREFERRED TYPE
    if (formik.values.preferredType == 1) {
      formik.setFieldValue("clubName", "");
    } else if (formik.values.preferredType == 2) {
      formik.setFieldValue("courseId", "");
    }
  }, [formik.values.preferredType]);

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const handleChange = (event, option) => {
    const fieldName = event.target?.id.split("-")[0];
    formik.setFieldValue(fieldName, option.id);
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Action"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          {row ? (
            <EditButton
              disabled={false}
              size="small"
              variant={"outlined"}
              action={() => setOpen(true)}
            >
              Edit Lead
            </EditButton>
          ) : (
            <AddButton size={"large"} action={() => setOpen(true)}>
              Add Lead
            </AddButton>
          )}
        </>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Stack gap={2}>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="leadName"
                    label="Lead Name"
                    name="leadName"
                    value={formik.values.leadName}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.leadName && Boolean(formik.errors.leadName)
                    }
                    helperText={
                      formik.touched.leadName && formik.errors.leadName
                    }
                  />
                </Box>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="age"
                    type="number"
                    label="Age"
                    name="age"
                    value={formik.values.age}
                    onChange={formik.handleChange}
                    error={formik.touched.age && Boolean(formik.errors.age)}
                    helperText={formik.touched.age && formik.errors.age}
                    onWheel={(e) => e.target.blur()}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                </Box>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="place"
                    type="text"
                    label="Place"
                    name="place"
                    value={formik.values.place}
                    onChange={formik.handleChange}
                    error={formik.touched.place && Boolean(formik.errors.place)}
                    helperText={formik.touched.place && formik.errors.place}
                  />
                </Box>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="email"
                    type="email"
                    label="Email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Box>
                <Box>
                  <GlobalSelectField
                    options={{
                      formik: formik,
                      label: "Gender",
                      name: "gender",
                      data: genders,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                      sx: {
                        width: "100%",
                      },
                    }}
                  />
                </Box>
                <Box>
                  <Autocomplete
                    disabled={loading}
                    name="class"
                    id="class"
                    options={classes}
                    getOptionLabel={(option) => option.className || ""}
                    value={
                      classes?.find(
                        (syllabus) => syllabus.id == formik.values.class
                      ) || null
                    }
                    onChange={handleChange}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Class"
                        error={
                          formik.touched.class &&
                          Boolean(formik.errors.class)
                        }
                        helperText={
                          formik.touched.class && formik.errors.class
                        }
                      />
                    )}
                  />
                </Box>
               
                <Box>
                  <Autocomplete
                    disabled={loading}
                    name="syllabusId"
                    id="syllabusId"
                    options={syllabuses}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      syllabuses?.find(
                        (syllabus) => syllabus.id == formik.values.syllabusId
                      ) || null
                    }
                    onChange={handleChange}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Syllabus"
                        error={
                          formik.touched.syllabusId &&
                          Boolean(formik.errors.syllabusId)
                        }
                        helperText={
                          formik.touched.syllabusId && formik.errors.syllabusId
                        }
                      />
                    )}
                  />
                </Box>
                <Box>
                  <GlobalSelectField
                    options={{
                      formik: formik,
                      label: "Preferred Type",
                      name: "preferredType",
                      data: preferredTypes,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                      sx: {
                        width: "100%",
                      },
                    }}
                  />
                </Box>
                {formik.values.preferredType == 1 ? (
                  <Box>
                    <Autocomplete
                      disabled={loading}
                      name="courseId"
                      id="courseId"
                      options={courses}
                      getOptionLabel={(option) => option.courseName || ""}
                      value={
                        courses?.find((course) =>
                          formik.values.courseId
                            ? course.id == formik.values.courseId
                            : ""
                        ) || null
                      }
                      onChange={handleChange}
                      renderInput={(params) => (
                        <TextField
                          disabled
                          fullWidth
                          autoComplete="off"
                          {...params}
                          label="Course"
                          error={
                            formik.touched.courseId &&
                            Boolean(formik.errors.courseId)
                          }
                          helperText={
                            formik.touched.courseId && formik.errors.courseId
                          }
                        />
                      )}
                    />
                  </Box>
                ) : formik.values.preferredType == 2 ? (
                  <Box>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id="clubName"
                      label="Club Name"
                      name="clubName"
                      value={formik.values.clubName}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.clubName &&
                        Boolean(formik.errors.clubName)
                      }
                      helperText={
                        formik.touched.clubName && formik.errors.clubName
                      }
                    />
                  </Box>
                ) : null}
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="parentName"
                    label="Parent Name"
                    name="parentName"
                    value={formik.values.parentName}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.parentName &&
                      Boolean(formik.errors.parentName)
                    }
                    helperText={
                      formik.touched.parentName && formik.errors.parentName
                    }
                  />
                </Box>
                <Stack direction={{ xs: "column", md: "row" }} gap={1}>
                  <Box sx={{ flex: 0.5 }}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      type="number"
                      id="countryCode"
                      label="Country Code"
                      name="countryCode"
                      value={formik.values.countryCode}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.countryCode &&
                        Boolean(formik.errors.countryCode)
                      }
                      helperText={
                        formik.touched.countryCode && formik.errors.countryCode
                      }
                      onWheel={(e) => e.target.blur()}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      type="number"
                      autoComplete="off"
                      fullWidth
                      id="contactNumber"
                      label="Contact Number"
                      name="contactNumber"
                      value={formik.values.contactNumber}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.contactNumber &&
                        Boolean(formik.errors.contactNumber)
                      }
                      helperText={
                        formik.touched.contactNumber &&
                        formik.errors.contactNumber
                      }
                      onWheel={(e) => e.target.blur()}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  onWheel: (e) => e.target.blur(),
                                }}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      type="number"
                      id="whatsappNumber"
                      label="Whatsapp Number"
                      name="whatsappNumber"
                      value={formik.values.whatsappNumber}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.whatsappNumber &&
                        Boolean(formik.errors.whatsappNumber)
                      }
                      helperText={
                        formik.touched.whatsappNumber &&
                        formik.errors.whatsappNumber
                      }
                      onWheel={(e) => e.target.blur()}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  onWheel: (e) => e.target.blur(),
                                }}
                    />
                  </Box>
                </Stack>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    multiline
                    maxRows={4}
                    variant="filled"
                    autoComplete="off"
                    id="remarks"
                    label="Remarks"
                    name="remarks"
                    value={formik.values.remarks}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.remarks && Boolean(formik.errors.remarks)
                    }
                    helperText={formik.touched.remarks && formik.errors.remarks}
                  />
                </Box>
              </Stack>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <CancelButton action={() => handleCancel()}>
                    Cancel
                  </CancelButton>
                  {row ? (
                    <UpdateButton disabled={loading} type="submit">
                      {loading ? "Updating..." : "Update"}
                    </UpdateButton>
                  ) : (
                    <SubmitButton disabled={loading} type="submit">
                      {loading ? "Submiting..." : "Submit"}
                    </SubmitButton>
                  )}
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddOrEditLeadDeo;
